<div class="credit-rule-mapping-dialog">
  <mat-dialog-content>
    <h3 class="header">Credit Rule</h3>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input [formControl]="formControlName" matInput placeholder="Enter credit rule name" type="text">
        </mat-form-field>
      </div>
      <div class="col-lg-6 col-md-12">
        <mat-form-field>
          <mat-label>Level</mat-label>
          <mat-select [formControl]="formControlLevel">
            <mat-option [value]="'Application'">Application</mat-option>
            <mat-option [value]="'Entity'">Entity</mat-option>
            <mat-option [value]="'Individual'">Individual</mat-option>
            <mat-option [value]="'Accreditation'">Accreditation</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <mat-form-field>
          <mat-label>Alert</mat-label>
          <mat-select [formControl]="formControlAlertId">
            @for (option of alertOptions; track option) {
              <mat-option [value]="option.id">{{option.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-6 col-md-12">
        <mat-form-field>
          <mat-label>Action (executed subject to the satisfaction of the credit rule)</mat-label>
          <mat-select [formControl]="formControlAction">
            @for (option of creditRuleMappingActionOptions; track option) {
              <mat-option [value]="option">{{option}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      @if (nodeType === 'route') {
        <div class="col-lg-6 col-md-12">
          <mat-form-field>
            <mat-label>Next Node</mat-label>
            <mat-select [formControl]="formControlNextNode">
              @for (option of nextNodeOptions; track option) {
                <mat-option [value]="option.id">{{option.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (formControlLevel.value === 'Entity' || formControlLevel.value === 'Individual') {
        <div class="col-lg-6 col-md-12">
          <mat-form-field>
            <mat-label>Condition for Entities/Individuals</mat-label>
            <mat-select [formControl]="formControlConditionVariable">
              @for (option of creditRuleItemOptions; track option) {
                <mat-option [value]="option.id">{{option.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
    <mat-divider></mat-divider>
    <div class="row mt-2">
      <div class="col-12">
        <credit-rule [formControl]="formControlRule" [getCreditRuleItemsFn]="getCreditRuleItemsFn"></credit-rule>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" class="width-100">
          <button color="primary" (click)="onCancel()" mat-stroked-button>Close</button>
          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
            <button color="primary" [disabled]="!formGroup.valid && !readOnly" (click)="onEvaluate()" mat-flat-button>Evaluate</button>
            @if (!readOnly) {
              <button color="primary" [disabled]="!formGroup.valid" (click)="onSubmit()" mat-flat-button>Confirm</button>
            }
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
